// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_12798_HEYIMMO = 'PPA_12798_HEYIMMO',
  PPA_12731_AI_DATA_EXTRACTION_REENTRY = 'PPA_12731_AI_DATA_EXTRACTION_REENTRY',
  PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION = 'PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_12798_HEYIMMO]: false,
  [FeatureSwitch.PPA_12731_AI_DATA_EXTRACTION_REENTRY]: false,
  [FeatureSwitch.PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_12798_HEYIMMO]: true,
  [FeatureSwitch.PPA_12731_AI_DATA_EXTRACTION_REENTRY]: true,
  [FeatureSwitch.PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
